import { $forwardedMessages, toggleSelectMode } from '../chat/chat.model';
import { ChatGate } from '../root/root.model';
import { $messagesForForward, changeMessagesForForward } from './forward-messages.model';

$messagesForForward
  .on(toggleSelectMode, () => [])
  .on(changeMessagesForForward, (_, messages) => messages)
  .reset(ChatGate.close, $forwardedMessages);
